(function () {
  'use strict';
  var NARANJA = '#FF5B14';
  var MINIMO = 2; // ya no se vende 1 sola pasta (pedido del usuario 2026-10-22)

  /* Nunca dejar la cantidad del formulario por debajo de 2 */
  function initMinimo() {
    document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]').forEach(function (inp) {
      if (inp.dataset.pyMin) return;
      inp.dataset.pyMin = '1';
      inp.min = MINIMO;
      if (Number(inp.value) < MINIMO) inp.value = MINIMO;
      ['input', 'change', 'blur'].forEach(function (ev) {
        inp.addEventListener(ev, function () { if (Number(inp.value) < MINIMO) inp.value = MINIMO; });
      });
    });
  }

  /* Ofertas 1/2/3 → fija la cantidad del formulario que lee el botón de pago contra entrega */
  function initOfertas() {
    document.querySelectorAll('[data-py-producto]').forEach(function (root) {
      if (root.dataset.pyListo) return;
      root.dataset.pyListo = '1';
      var ofertas = root.querySelectorAll('[data-py-oferta]');
      var precio = root.querySelector('[data-py-precio]');
      var antes = root.querySelector('[data-py-antes]');
      var ahorro = root.querySelector('[data-py-ahorro]');
      var nota = root.querySelector('[data-py-nota]');
      function fijar(o) {
        var q = Math.max(MINIMO, Number(o.getAttribute('data-cantidad')) || MINIMO);
        document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]').forEach(function (inp) {
          inp.value = q;
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
        if (precio) precio.textContent = o.getAttribute('data-precio');
        if (antes) { antes.textContent = o.getAttribute('data-antes') || ''; antes.hidden = !o.getAttribute('data-antes'); }
        if (ahorro) { ahorro.textContent = o.getAttribute('data-ahorro') || ''; ahorro.hidden = !o.getAttribute('data-ahorro'); }
        if (nota) nota.textContent = o.getAttribute('data-nota') || '';
      }
      ofertas.forEach(function (o) {
        o.querySelector('input').addEventListener('change', function () {
          ofertas.forEach(function (x) { x.classList.toggle('is-activa', x === o); });
          fijar(o);
        });
      });
      var marcada = root.querySelector('[data-py-oferta] input:checked');
      if (marcada) fijar(marcada.closest('[data-py-oferta]'));

      // Puntos de la galería
      var pista = root.querySelector('.py-galeria__pista');
      var puntos = root.querySelectorAll('.py-galeria__puntos span');
      if (pista && puntos.length) {
        pista.addEventListener('scroll', function () {
          var i = Math.round(pista.scrollLeft / pista.clientWidth);
          puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        }, { passive: true });
      }
    });
  }

  /* Botones "ir a comprar" con desplazamiento suave */
  function initAnclas() {
    document.querySelectorAll('[data-py-ancla]').forEach(function (a) {
      if (a.dataset.pyListo) return;
      a.dataset.pyListo = '1';
      a.addEventListener('click', function (e) {
        var destino = document.querySelector(a.getAttribute('href'));
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* El botón de EasySell trae su color "a fuego": lo pintamos naranja solo en esta página */
  function initBotonPago() {
    function pintar() {
      document.querySelectorAll('.py-apps .es-popup-button-product, .es-sticky-product').forEach(function (b) {
        if (b.dataset.pyPintado) return;
        b.dataset.pyPintado = '1';
        b.style.setProperty('background', NARANJA, 'important');
        b.style.setProperty('border-color', NARANJA, 'important');
        b.style.setProperty('border-radius', '14px', 'important');
        b.style.setProperty('color', '#fff', 'important');
      });
    }
    pintar();
    var mo = new MutationObserver(pintar);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  function init() { initMinimo(); initOfertas(); initAnclas(); initBotonPago(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
